import { render } from "./PagePath.vue?vue&type=template&id=6740173e&scoped=true&ts=true&lang=html"
import script from "./PagePath.vue?vue&type=script&lang=ts"
export * from "./PagePath.vue?vue&type=script&lang=ts"

import "./PagePath.vue?vue&type=style&index=0&id=6740173e&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6740173e"]])

export default __exports__